$(document).ready(function () {
  $(".loan-accordion .accordion-header").on("click", function () {
    $(this).next().toggle("slow");
    $(this).toggleClass("active");
    let buttonText = $(this).find(".btn-text");

    if (buttonText.text() === "Approfondisci") {
      buttonText.text("Mostra meno");
    } else {
      buttonText.text("Approfondisci");
    }
  });
});
